















































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IPayment } from "@/models/payment";
import _ from "@/boot/lodash";
import Context from "@/mixins/context";

@Component
export default class InvoicePaymentItem extends Mixins(Context) {
  // Props

  @Prop({ default: null })
  public payment!: IPayment;

  @Prop({ default: true })
  public isLoading!: boolean;

  // Computed

  public get gatewayName() {
    const { gateway } = this.payment;
    if (!gateway) return this.$t("_.account_credit");
    return gateway?.name_translated || gateway?.name;
  }

  public get paymentDetail() {
    const { payment_details } = this.payment;
    if (!payment_details) return "";
    return _.compact([
      _.upperFirst(payment_details?.card_type),
      "••••",
      payment_details?.card_last4
    ]).join(" ");
  }

  public openLogModal() {
    if (!this.payment || !this.isAdmin) return;
    return this.$store.dispatch(`data/${DataModules.LOGS}/openLogModal`, {
      props: {
        log: this.payment.payment_log,
        title: this.$t("_.transaction_num", {
          number: this.payment.transaction_id as string
        })
      }
    });
  }
}
